import React from 'react';
import { ShieldCheckIcon, CheckCircle2Icon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4" data-id="element-66">
      <div className="max-w-4xl mx-auto" data-id="element-67">
        <div className="bg-gradient-to-r from-white to-[#FEF3E2] rounded-3xl p-8 md:p-12 border border-[#D4850A]/20 flex flex-col md:flex-row items-center gap-8 md:gap-12 shadow-lg" data-id="element-68">
          <div className="flex-shrink-0" data-id="element-69">
            <div className="w-32 h-32 md:w-40 md:h-40 bg-[#D4850A]/10 rounded-full flex items-center justify-center border-4 border-[#D4850A]/20" data-id="element-70">
              <ShieldCheckIcon className="w-16 h-16 md:w-20 md:h-20 text-[#D4850A]" data-id="element-71" />
            </div>
          </div>

          <div data-id="element-72">
            <h2 className="text-3xl font-bold mb-4 text-[#3D2B1F]" data-id="element-73">
              Garantía Total de <span className="text-[#D4850A]" data-id="element-74">45 Días</span>
            </h2>
            <p className="text-lg text-[#6B5344] mb-4" data-id="element-75">
              Una vez que completes tu compra podrás descargar el recetario
              inmediatamente y empezar a preparar tus primeros budines hoy
              mismo.
            </p>
            <p className="text-lg text-[#6B5344] mb-4" data-id="element-76">
              Si por cualquier motivo sientes que este recetario no cumplió tus
              expectativas, simplemente pides el reembolso y{' '}
              <strong className="text-[#3D2B1F]" data-id="element-77">
                te devolvemos el 100% de tu dinero. Sin preguntas.
              </strong>
            </p>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-78">
              <span className="flex items-center gap-1.5 text-sm text-green-600 font-medium bg-green-50 px-3 py-1.5 rounded-full" data-id="element-79">
                <CheckCircle2Icon className="w-4 h-4" data-id="element-80" /> Sin riesgo
              </span>
              <span className="flex items-center gap-1.5 text-sm text-green-600 font-medium bg-green-50 px-3 py-1.5 rounded-full" data-id="element-81">
                <CheckCircle2Icon className="w-4 h-4" data-id="element-82" /> Reembolso completo
              </span>
              <span className="flex items-center gap-1.5 text-sm text-green-600 font-medium bg-green-50 px-3 py-1.5 rounded-full" data-id="element-83">
                <CheckCircle2Icon className="w-4 h-4" data-id="element-84" /> Sin preguntas
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}